{
    "name": "masar-web",
    "version": "2.28.0",
    "private": true,
    "description": "Masar web project",
    "scripts": {
        "buildProd": "export NG_ENV='production' && export NODE_OPTIONS='--max_old_space_size=8192' && ng build masar --configuration=production --aot",
        "buildStaging": "export NG_ENV='staging' && export NODE_OPTIONS='--max_old_space_size=8192' && ng build masar --configuration=staging --aot",
        "lint": "ng lint",
        "ng": "ng",
        "start": "npm --prefix .. run dev"
    },
    "dependencies": {
        "@angular/cdk": "^22.1.7",
        "@angular/common": "^22.1.7",
        "@angular/compiler": "^22.1.7",
        "@angular/core": "^22.1.7",
        "@angular/forms": "^22.1.7",
        "@angular/platform-browser": "^22.1.7",
        "@angular/router": "^22.1.7",
        "@azure/msal-angular": "^6.2.1",
        "@azure/msal-browser": "^5.22.0",
        "@m6d/cerebro": "^1.0.0",
        "@microsoft/signalr": "^3.1.7",
        "@ng-omar/translation": "12.0.8",
        "@ng-select/ng-select": "23.6.0",
        "@ngx-translate/core": "^15.0.0",
        "@tailwindcss/typography": "^0.5.16",
        "@types/chart.js": "^2.9.24",
        "@types/marked": "^6.0.0",
        "animate.css": "^4.1.1",
        "chart.js": "^2.9.3",
        "chartjs-plugin-datalabels": "^1.0.0",
        "chartjs-plugin-labels": "^1.1.0",
        "convex": "^1.29.0",
        "date-fns": "^3.6.0",
        "file-saver": "^2.0.2",
        "flatpickr": "4.6.6",
        "gaugeJS": "^1.3.7",
        "html2canvas": "^1.4.1",
        "jspdf": "^2.5.1",
        "marked": "^15.0.12",
        "mnm-frappe-gantt": "^0.6.3",
        "mnm-webapp": "^5.0.1",
        "mobile-device-detect": "^0.4.3",
        "ng-zorro-antd": "^22.1.1",
        "ngx-color-picker": "^20.1.1",
        "ngx-date-fns": "^11.0.1",
        "rxjs": "^7.8.1",
        "simple-statistics": "^7.8.2",
        "tslib": "^2.0.0",
        "zone.js": "~0.16.0"
    },
    "devDependencies": {
        "@angular-eslint/builder": "^22.5.0",
        "@angular-eslint/eslint-plugin": "^22.5.0",
        "@angular-eslint/eslint-plugin-template": "^22.5.0",
        "@angular-eslint/schematics": "^22.5.0",
        "@angular-eslint/template-parser": "^22.5.0",
        "@angular/build": "^22.1.8",
        "@angular/cli": "^22.1.8",
        "@angular/compiler-cli": "^22.1.7",
        "@angular/language-service": "^22.1.7",
        "@tailwindcss/forms": "^0.3.3",
        "@types/file-saver": "^2.0.1",
        "@types/node": "^24.0.0",
        "angular-eslint": "^22.5.0",
        "autoprefixer": "^10.4.12",
        "eslint": "^9.39.0",
        "eslint-plugin-import": "^2.32.0",
        "eslint-plugin-prettier": "^5.5.0",
        "mnm-tailwindcss-rtl": "^0.9.9",
        "postcss": "^8.4.17",
        "prettier": "^3.9.0",
        "prettier-plugin-tailwindcss": "^0.8.1",
        "tailwindcss": "^3.4.17",
        "typescript": "~6.0.3",
        "typescript-eslint": "^8.70.0"
    },
    "engines": {
        "node": "^24.15.0",
        "npm": ">=10"
    }
}
